import { atom } from 'jotai';
import { IUserInfoResponse } from '../services/login.service';

export const userInfoAtom = atom<IUserInfoResponse | null>(null);
